import BoldText from '@/components/BoldText';
import CustomBadge from '@/components/CustomBadge';
import userPlans from '@/hooks/userPlans';
import { handleChangePreview, previewSelector } from '@/redux/slice/preview.slice';
import { Editor } from '@monaco-editor/react';
import { Card, Divider } from '@shopify/polaris';
import { CSSProperties } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function CustomCSS() {
  const dispatch = useDispatch();
  const previewDetail = useSelector(previewSelector);
  const { isUserFreeOrBasicLimited } = userPlans();

  const handleChange = (value: string | undefined) => {
    if (isUserFreeOrBasicLimited) {
      return;
    }

    dispatch(handleChangePreview({ customCss: value }));
  };

  const styleEditor: CSSProperties = {
    pointerEvents: isUserFreeOrBasicLimited ? 'none' : 'auto',
    opacity: isUserFreeOrBasicLimited ? 0.5 : 1,
  };

  return (
    <Card>
      <BoldText>CSS {isUserFreeOrBasicLimited && <CustomBadge />}</BoldText>
      <div className="mt-8 mb-8">
        <Divider />
      </div>

      <div style={styleEditor}>
        <Editor
          height="400px"
          onChange={(value) => handleChange(value)}
          defaultLanguage="css"
          theme="vs-dark"
          defaultValue={previewDetail.customCss || ''}
          options={{
            automaticLayout: true,
          }}
          value={previewDetail.customCss || ''}
        />
      </div>
    </Card>
  );
}

export default CustomCSS;
